/* Utils */
import {
  getFirstGenre,
  useFullEpisodeName,
  isEpisode,
  getRating,
  joinArrayWithSpace,
} from '../../utils/metaDataUtils';

export function useSubtitleCardStationWithSchedule(content) {
  const fullEpisodeName = useFullEpisodeName(content);
  if (isEpisode(content)) {
    return joinArrayWithSpace([
      getRating(content),
      fullEpisodeName,
    ]);
  }

  return joinArrayWithSpace([
    getRating(content),
    getFirstGenre(content),
  ]);
}
